import { api as apiClient } from '@/common/api';
import { notificationEndpoints } from '@/common/api/endpoints';

export interface NotificationData {
  id: string;
  userId: string;
  type:
    | 'FRIEND_REQUEST'
    | 'FRIEND_ACCEPTED'
    | 'INCOMING_FUNDS'
    | 'PAYMENT_MADE'
    | 'PAYOUT_SOON'
    | 'INFO';
  title: string;
  body: string;
  data: Record<string, unknown> | null;
  read: boolean;
  readAt: string | null;
  createdAt: string;
  deliverDate: string;
}

export interface NotificationsResponse {
  notifications: NotificationData[];
  total: number;
  page: number;
  limit: number;
}

export interface PushSubscriptionPayload {
  endpoint: string;
  keys: {
    p256dh: string;
    auth: string;
  };
}

export async function getNotifications(
  page = 1,
  limit = 20,
): Promise<NotificationsResponse> {
  return await apiClient.get<NotificationsResponse>(
    `${notificationEndpoints.list}?page=${page}&limit=${limit}`,
  );
}

export async function getUnreadCount(): Promise<number> {
  const res = await apiClient.get<{ count: number }>(notificationEndpoints.unreadCount);
  return res.count;
}

export async function markNotificationRead(id: string): Promise<void> {
  await apiClient.patch(notificationEndpoints.markRead(id), {});
}

export async function markAllNotificationsRead(): Promise<void> {
  await apiClient.patch(notificationEndpoints.markAllRead, {});
}

export async function savePushSubscription(
  subscription: PushSubscriptionPayload,
): Promise<void> {
  await apiClient.post(notificationEndpoints.savePushSubscription, subscription);
}

export async function removePushSubscription(endpoint: string): Promise<void> {
  await apiClient.delete(notificationEndpoints.removePushSubscription, { data: { endpoint } });
}
